<template>
  <div>
    <div
      class="modal fade"
      ref="modalDisableUpsell"
      id="modalDisableUpsell"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalDisableUpsell"
      v-if="!closePopUpDisableUpsell"
    >
      <div
        class="modal-dialog modal-md"
        role="document"
      >
        <div
          class="modal-content"
        >
          <div class="modal-header bg-danger">
            <h5 class="modal-title">
              <span>
                <i class="fa-solid fa-envelope-open-dollar mr-2" />{{ $t("Subscription Expired") }}
              </span>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="closeModal()"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <div class=" text-center">
              <div>
                <img
                  :src="$storeIndex.getImageSrc('banner-subscription-expired')"
                  class="mb-3 img-fluid"
                  style="width:110px;"
                >
              </div>
              <div class="h4">
                {{ $t("Subscription Expired") }}!
              </div>
              <div class="px-2">
                {{ $t("Your package has expired.") }} {{ $t("If you want to continue using it, please press 'Upgrade Now'.") }}
                <br>
                {{ $t("If you want to cancel upsell, please press the 'Cancel Upsell' button.") }}
                <br>
                {{ $t("Your order cannot be upselled again.") }}
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <button
              type="button"
              class="btn btn-outline-danger mr-3"
              data-dismiss="modal"
              @click="closeDisableUpsell()"
            >
              <i class="fa-regular fa-thumbs-up fa-1x mr-1" /> {{ $t('Cancel Upsell') }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="redirectTo()"
            >
              <i class="fa-solid fa-envelope-open-dollar fa-1x mr-1" /> {{ $t('Upgrade Now') }}!
            </button>
          </div>
        </div>
        <!-- check showPlaceholder -->
      </div>
    </div>
  </div>
</template>
<script>
import {
    localSave,
    localRead
} from "@/store/lang";

import moment from "moment";
import Cookies from 'js-cookie';
import Api from "@/services/endpoint/tenant.service.js";

export default {
	name : "ModalDisableUpsell",
	components: {
	},
	data (){
		return{
				lang: localRead("local"),
        closePopUpDisableUpsell: false,
				// closePlanPacketTrial: false,
        settingUpsellId: 1,
        tenant: JSON.parse(Cookies.get('tenant'))
		}
	},
	watch:{
	},
  mounted() {
    this.showModal();

    $(this.$refs.modalDisableUpsell).on("hidden.bs.modal", () => {
      this.$parent.showDisableUpsell = false;
    });
  },
	methods : {
    async disableUpsell() {
      return await Api.SettingV2.putUpsellDisable({ enable: 0 });
    },
		async closeDisableUpsell() {
      this.disableUpsell();
      Cookies.set('closeDisableUpsell_'+this.tenant.id, 'true', { domain: '.' + process.env.CENTRAL_API_ROOT, expires: 1  });
      this.$store.dispatch("user/showPlanNoti", false);
		},
    showModal() {
      setTimeout(() => {
        $('#modalDisableUpsell').modal('show');
      }, 500);
    },
    closeModal(){
      this.disableUpsell();
      let closePopUpDisableUpsell = Cookies.set('closeDisableUpsell_'+this.tenant.id, 'true', { domain: '.' + process.env.CENTRAL_API_ROOT, expires: 1  });
      if(closePopUpDisableUpsell) {
        this.$parent.closePopUpDisableUpsell = closePopUpDisableUpsell;
      }
      this.$parent.showDisableUpsell = false;
      this.$parent.showPopUp();
    },
    redirectTo(){
      try {
        Cookies.set('clickUpgrade_'+this.tenant.id, 'true', { domain: '.' + process.env.CENTRAL_API_ROOT, expires: 1  });
        this.$nextTick( () => {
          this.$router.push({ name: "t.a.premium.subscriptions.select"});
        });
      } catch (err) {
        console.log(err);
      }
    }
	},
}
</script>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/ModalDisableUpsell.vue